// src/Dashboard/pages/user/Galleries/components/AlbumsToolbar.jsx

import React from "react";
import {
  FaEye,
  FaFilter,
  FaPlus,
  FaSearch,
  FaTimes,
} from "react-icons/fa";

export default function AlbumsToolbar({
  ui,
  updateUi,
  debouncedQ,
  setDebouncedQ,
  isManager,
  onReset,
  onCreate,
}) {
  const fieldClass =
    "w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white";

  return (
    <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-900/60">
      <div className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 text-sm font-bold text-slate-900 dark:text-white">
            <FaFilter />
            Filtres albums
          </div>

          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
            Recherchez un album, triez la liste ou affichez les albums masqués.
          </p>
        </div>

        <div className="flex flex-wrap gap-2">
          {isManager && (
            <button
              type="button"
              onClick={onCreate}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-3 py-2 text-xs font-bold text-white transition hover:bg-indigo-800"
            >
              <FaPlus />
              Créer
            </button>
          )}

          {isManager && (
            <button
              type="button"
              onClick={() => updateUi({ showAll: !ui.showAll })}
              className={`inline-flex items-center justify-center gap-2 rounded-2xl px-3 py-2 text-xs font-bold ring-1 transition ${
                ui.showAll
                  ? "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-500/20"
                  : "bg-white text-slate-700 ring-slate-200 hover:bg-slate-50 dark:bg-slate-950 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-900"
              }`}
            >
              <FaEye />
              {ui.showAll ? "Tous affichés" : "Actifs seulement"}
            </button>
          )}

          <button
            type="button"
            onClick={onReset}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-900 px-3 py-2 text-xs font-bold text-white transition hover:bg-slate-800 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100"
          >
            <FaTimes />
            Réinitialiser
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-4">
        <div className="lg:col-span-3">
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Recherche
          </label>

          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              type="text"
              value={debouncedQ}
              onChange={(event) => setDebouncedQ(event.target.value)}
              placeholder="Titre, description..."
              className="w-full rounded-2xl border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            />
          </div>
        </div>

        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Tri
          </label>

          <select
            value={ui.sort}
            onChange={(event) => updateUi({ sort: event.target.value })}
            className={fieldClass}
          >
            <option value="recent">Plus récents</option>
            <option value="oldest">Plus anciens</option>
            <option value="alpha">Titre A-Z</option>
          </select>
        </div>
      </div>
    </div>
  );
}